import {
  UseSuspenseQueryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query"
import type * as Api from "../../@client/api"
import { post } from "../post"
import { useHandleAsyncSafely } from "./use-handle-async-safely"

export function useSuspenseQueryPost<ActionName extends keyof Api.POST>(
  url: ActionName,
  input: Api.Input[ActionName],
  requestInit?: RequestInit,
  options?: UseSuspenseQueryOptions<
    Api.Output[ActionName],
    Error,
    Api.Output[ActionName],
    (ActionName | Api.Input[ActionName] | undefined)[]
  >
) {
  const handleAsyncSafely = useHandleAsyncSafely<Api.Output[ActionName]>()

  return useSuspenseQuery({
    retry: false,
    queryKey: [url, input],
    queryFn: () => handleAsyncSafely(() => post(url, input, requestInit)),
    ...options,
  })
}
